import { iconProps as a } from "./index647.js";
import { defineComponent as i, computed as m, openBlock as p, createElementBlock as l, mergeProps as f, unref as u, renderSlot as d } from "vue";
import { useNamespace as _ } from "./index559.js";
import { addUnit as h } from "./index641.js";
var B = /* @__PURE__ */ i({
  name: "ElIcon",
  inheritAttrs: !1,
  __name: "icon",
  props: a,
  setup(t) {
    const n = t, s = _("icon"), c = m(() => {
      const { size: e, color: o } = n, r = h(e);
      return !r && !o ? {} : {
        fontSize: r,
        "--color": o
      };
    });
    return (e, o) => (p(), l(
      "i",
      f({
        class: u(s).b(),
        style: c.value
      }, e.$attrs),
      [
        d(e.$slots, "default")
      ],
      16
      /* FULL_PROPS */
    ));
  }
});
export {
  B as default
};
